import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col } from "antd";
import { nanoid } from "nanoid";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addIssue } from "./ducks/boardReducer";
import AssigneeSelect from "./components/AssigneeSelect";
import { api } from "../../../services/api";

export default function NewIssueScreen() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [categories, setCategories] = useState<any>([]);
  console.log("🚀 ~ NewIssueScreen ~ categories:", categories);
  const [type, setType] = useState<any>([]);

  const [users, setUsers] = useState([]);

  const issues = useSelector((state: any) => state.board.issues);

  const onBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    fetchTicketCategory();
  }, []);

  useEffect(() => {
    fetchTicketType();
  }, []);
  const fetchTicketCategory = async () => {
    let body = {
      filter: {
        keyGroup: "ticket",
        category: "admin",
        "attributes.active": true,
      },
      projection: {
        value: 1,
        label: "$label.EN",
        _id: 0,
      },
    };

    try {
      let result = await api.getTicketCategories(body);
      setCategories(result);
    } catch (error) {}
  };

  const fetchTicketType = async () => {
    let body = {
      filter: {
        keyGroup: "ticket",
        category: "ticketType",
        "attributes.active": true,
      },
      projection: {
        value: 1,
        label: "$label.EN",
        _id: 0,
      },
    };

    try {
      let result = await api.getTicketType(body);
      setType(result);
    } catch (error) {}
  };

  const fetchUserList = async (param) => {
    if (!param) {
      return [];
    }
    const body = {
      search: "",
      _id: param || "",
    };

    try {
      const response = await api.getAllUsers(body);
      return response?.data || [];
    } catch (error) {
      console.error("Error fetching user list:", error);
      return [];
    }
  };

  const creatNewIssue = async (body) => {
    try {
      const result = await api.createIssue(body);
      console.log(result);
      navigate("/ticketing", { state: { newTicket: result.data } });
    } catch (error) {}
  };

  function submit() {
    let body = {};
    form.validateFields().then(async (values) => {
      body = {
        title: values.title.trim(),
        description: values.description || "",
        reason_code: values.category,
        assignee_id: values.assignee_id.key || values.assignee_id,
        priority: values.priority,
        type: values.type,
      };
      creatNewIssue(body);

      onBack();
    });
  }

  const dropdownCategories = categories.map((cat, index) => ({
    uiValue: cat.value + "__" + index, // ✅ unique for Select
    label: cat.label,
  }));

  return (
    <div style={{ padding: 24, maxWidth: 600, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
        <Button
          icon={<ArrowLeftOutlined />}
          type="text"
          onClick={onBack}
          style={{ marginRight: 12 }}
        />
        <h2 style={{ margin: 0 }}>Create Issue</h2>
      </div>

      <Form
        form={form}
        layout="vertical"
        className="new-issue-form"
        initialValues={{
          status: "todo",
          priority: 3,
          // type: "task",
          // category: "",
        }}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true }]}
          style={{ marginBottom: 24 }}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true }]}
          style={{ marginBottom: 24 }}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Priority"
              name="priority"
              rules={[{ required: true }]}
              style={{ marginBottom: 24 }}
            >
              <Select
                options={[
                  { value: 1, label: "P1" },
                  { value: 2, label: "P2" },
                  { value: 3, label: "P3" },
                  { value: 4, label: "P4" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Type"
              name="type"
              rules={[{ required: true }]}
              style={{ marginBottom: 24 }}
            >
              <Select placeholder="Select Type" options={type} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Category"
              name="category"
              rules={[{ required: true }]}
              style={{ marginBottom: 24 }}
            >
              <Select
                placeholder="Select Category"
                onChange={async (value) => {
                  const realId = value.split("__")[0];

                  try {
                    const usersResponse = await fetchUserList(realId);
                    const fetchedUsers = usersResponse || [];
                    setUsers(fetchedUsers);

                    if (fetchedUsers.length === 1) {
                      form.setFieldsValue({ assignee_id: fetchedUsers[0]._id });
                    }

                    const selected = dropdownCategories.find(
                      (cat) => cat.uiValue === value
                    );

                    form.setFieldsValue({
                      category: selected?.label,
                      category_id: selected?.realId,
                    });
                  } catch (error) {
                    console.error("Error fetching user list:", error);
                  }
                }}
              >
                {dropdownCategories.map((cat) => (
                  <Select.Option key={cat.uiValue} value={cat.uiValue}>
                    {cat.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Assignee"
              name="assignee_id"
              rules={[{ required: true, message: "Please select an assignee" }]}
              style={{ marginBottom: 24 }}
            >
              <AssigneeSelect
                data={users}
                onSearchUser={async (searchText) => {
                  try {
                    const response = await api.getAllUsers({
                      search: searchText,
                    });
                    setUsers(response?.data || []);
                  } catch (error) {
                    console.error("Error searching users:", error);
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ textAlign: "right", marginTop: 24 }}>
          <Button style={{ marginRight: 8 }} onClick={onBack}>
            Cancel
          </Button>
          <Button type="primary" onClick={submit}>
            Create
          </Button>
        </div>
      </Form>
    </div>
  );
}
